module.exports =  {
  home: {
    home:"首页",
    about: "关于我们",
    research: "自主研发",
    quality: "严控品质",
    academic: "全球学术",
    dynamic: "公司动态",
    news: "市场活动",
    product: "产品展示",
    contact: "联系我们",
    beijing: "北京",
    address: "地址",
    bjAddress: "中国北京市北京经济技术开发区永昌南路30号1幢",
    shanghai: "上海",
    shAddress: "上海市长宁区具体地址西路8号",
    copyright: "版权所有",
    companyName: "北京科仪邦恩医疗器械科技有限公司",
    more: "点击加载更多",
    noMoreData: "没有更多数据了",
    seeMore:'查看更多',
    personnelEmail:'人事邮箱',
    salesEmail:'销售邮箱',
    marketTel:'销售电话',
    email:'邮箱',
    contactPhoneText:'联系电话',
    contactPhoneTel:'+86 010 67850177/+86 18519401755 （国内合作）'
  }
}
